import token, { tokenToVars } from '../token';
import Menu from './menu';

export { Menu };
export default tokenToVars(Menu, token);
